import script from "./MailOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./MailOverview.vue?vue&type=script&setup=true&lang=js"

import "./MailOverview.vue?vue&type=style&index=0&id=d24689ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d24689ac"]])

export default __exports__